import React from 'react'
import useInput from 'tennders-common/form/hooks/useInput'
import ReactTooltip from 'react-tooltip'
import stylesInput from '@/styles/Input.module.scss'
import IconInfo from '../../../../../icons/icon-gen-info.svg'

type Props = {
  className ?: string,
  errors ?: Record<string, any>,
  form: Record<string, any>,
  name ?: string,
  disabled ?: boolean,
  onChange ?: (key: string, value: any) => void,
  renderInput?: (any) => JSX.Element,
  children?: JSX.Element,
  required?: boolean,
  labelClassName?: string,
  infoTooltip?:string
}

const InputOnlyDivContainer = (props: Props) => {
  const {
    className,
    errors,
    form,
    name,
    disabled,
    onChange,
    renderInput,
    children,
    labelClassName,
    infoTooltip,
    required
  } = props

  const { errorContent, errorText, value, onSet } = useInput({
    errors,
    form,
    name,
    onChange
  })

  return (
    <div className={className}>
      {(errorContent || infoTooltip) && (
        <label className={'form-label d-flex justify-end' + (labelClassName ? ` ${labelClassName}` : '')}>
          {errorContent && errorContent}
          {infoTooltip && (
            <span className="d-flex align-center">
              <IconInfo data-tip data-for={name + '1'} />
              <ReactTooltip id={name + '1'} className="custom-color-tooltip" type="info">
                {infoTooltip}
              </ReactTooltip>
            </span>
          )}
        </label>
      )}
      {renderInput({ form, error: errorText, name, onSet, value, disabled, required })}
      {children}
    </div>
  )
}

export default React.memo<Props>(InputOnlyDivContainer)
